"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftTimeWorkedDtoTypeEnum = void 0;
exports.instanceOfShiftTimeWorkedDto = instanceOfShiftTimeWorkedDto;
exports.ShiftTimeWorkedDtoFromJSON = ShiftTimeWorkedDtoFromJSON;
exports.ShiftTimeWorkedDtoFromJSONTyped = ShiftTimeWorkedDtoFromJSONTyped;
exports.ShiftTimeWorkedDtoToJSON = ShiftTimeWorkedDtoToJSON;
exports.ShiftTimeWorkedDtoToJSONTyped = ShiftTimeWorkedDtoToJSONTyped;
/**
 * @export
 */
exports.ShiftTimeWorkedDtoTypeEnum = {
    OnCall: 'ON_CALL',
    CalledIn: 'CALLED_IN',
    Standard: 'STANDARD'
};
/**
 * Check if a given object implements the ShiftTimeWorkedDto interface.
 */
function instanceOfShiftTimeWorkedDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    if (!('mealBreakMinutes' in value) || value['mealBreakMinutes'] === undefined)
        return false;
    return true;
}
function ShiftTimeWorkedDtoFromJSON(json) {
    return ShiftTimeWorkedDtoFromJSONTyped(json, false);
}
function ShiftTimeWorkedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'type': json['type'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'minutesWorked': json['minutesWorked'],
        'mealBreakMinutes': json['mealBreakMinutes'],
    };
}
function ShiftTimeWorkedDtoToJSON(json) {
    return ShiftTimeWorkedDtoToJSONTyped(json, false);
}
function ShiftTimeWorkedDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'type': value['type'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'minutesWorked': value['minutesWorked'],
        'mealBreakMinutes': value['mealBreakMinutes'],
    };
}
//# sourceMappingURL=ShiftTimeWorkedDto.js.map